import React from 'react'

interface CloseIconProps {
  className?: string
  stroke?: string
}

export const CloseIcon: React.FC<CloseIconProps> = ({
  className = 'size-4',
  stroke = 'currentColor',
}) => (
  <svg
    className={className}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path d="M4 4L12 12M12 4L4 12" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" />
  </svg>
)
